import React, { type ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface TooltipProps {
  content: string | undefined | null;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children, position = 'top', className }) => {
  if (!content) return <>{children}</>;

  const positionClasses = {
    top: 'bottom-full left-0 mb-2',
    bottom: 'top-full left-0 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const arrowClasses = {
    top: 'top-full left-4 -mt-px border-t-[#1e293b] border-l-transparent border-r-transparent border-b-transparent',
    bottom: 'bottom-full left-4 -mb-px border-b-[#1e293b] border-l-transparent border-r-transparent border-t-transparent',
    left: 'left-full top-1/2 -translate-y-1/2 -ml-px border-l-[#1e293b] border-t-transparent border-b-transparent border-r-transparent',
    right: 'right-full top-1/2 -translate-y-1/2 -mr-px border-r-[#1e293b] border-t-transparent border-b-transparent border-l-transparent',
  };

  return (
    <div className="group relative block w-full">
      {children}
      <div 
        className={cn(
          "pointer-events-none invisible absolute z-[9999] opacity-0 transition-opacity bg-[#1e293b] text-white text-[13px] font-medium leading-normal rounded-[4px] py-2 px-3 shadow-md whitespace-nowrap",
          "group-hover:visible group-hover:opacity-100",
          positionClasses[position],
          className
        )}
        style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
      >
        {content}
        <div className={cn("absolute border-[5px]", arrowClasses[position])} />
      </div>
    </div>
  );
};
